import React from 'react';

interface ErrorBoundaryState {
  err: any;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { err: null };
  }

  componentDidCatch(err: any, errorInfo: any) {
    this.setState({ err });
    console.error('[ErrorBoundary]', err, errorInfo);
  }

  static getDerivedStateFromError(error: any) {
    return { err: error };
  }

  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen p-8 text-red-700 bg-red-50 flex items-center justify-center">
          <div className="max-w-2xl text-center">
            <h1 className="text-2xl font-bold mb-4">🚨 Erreur d'exécution MemoMundi.ai</h1>
            <div className="bg-white p-4 rounded-lg border border-red-200 mb-4">
              <h2 className="font-semibold mb-2">Message d'erreur :</h2>
              <pre className="text-sm text-left whitespace-pre-wrap text-red-600 bg-red-50 p-3 rounded">
                {String(this.state.err?.message || this.state.err)}
              </pre>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Recharger la page
            </button>
            <p className="text-sm text-red-600 mt-4">
              Si le problème persiste, contactez l'équipe technique.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}